import { IMG_CDN_URL } from "../../../utils/links/link.js";
//import { useContext } from "react";
//import UserContext from "../utils/UserContext";

const SingleProduct = ({
  // name,
  // cuisines,
  // cloudinaryImageId,
  // lastMileTravelString,
  props
}) => {
  //const { user } = useContext(UserContext);
  //console.log(props);
  return (
    
    // <div  style={{width:'56px',height:'60px',padding:'2px',margin:'2px'}}>
    //   <img src={IMG_CDN_URL + cloudinaryImageId} />
    //   <h2  style={{fontStyle:'bold'}}>{name}</h2>
    //   <h3>{cuisines.join(", ")}</h3>
    //   <h4>{lastMileTravelString}</h4>
    //   {/* <h5 className="font-bold">
    //     {user.name} - {user.email}
    //   </h5> */}
    // </div>
   <div></div>
  );
};

export default SingleProduct

//className="w-56 p-2 m-2 shadow-lg bg-pink-50"
//className="font-bold text-xl"